import { render, staticRenderFns } from "./StudentMarksheet.html?vue&type=template&id=5af65318&scoped=true&external"
import script from "./StudentMarksheet.vue?vue&type=script&lang=js"
export * from "./StudentMarksheet.vue?vue&type=script&lang=js"
import style0 from "./StudentMarksheet.css?vue&type=style&index=0&id=5af65318&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af65318",
  null
  
)

export default component.exports